<template>
  <v-app id="License">
    <v-content>
      <v-container>
        <v-row
          dense
          max-width="100"
        >
          <v-col
            cols="12"
          >
            <h3>商標等について</h3>
          </v-col>
          <v-col
            cols="12"
          >
            EPSONはセイコーエプソン株式会社の登録商標です。
          </v-col>
          <v-col
            cols="12"
          >
            Google ChromeはGoogle Inc.の商標または登録商標です。
          </v-col>
          <v-col
            cols="12"
          >
            Microsoft Edgeは、Microsoft Corporationの米国およびその他の国における登録商標または商標です。
          </v-col>
          <v-col
            cols="12"
          >
            Safariは、米国Apple Computer, Inc.の商標または登録商標です。
          </v-col>
          <v-col
            cols="12"
          >
            QRコードは(株)デンソーウェーブの登録商標です。
          </v-col>
          <v-col
            cols="12"
          >
            その他記載されている会社名、製品名は、各社の登録商標または商標です。
          </v-col>
        </v-row>
        <br>
        <v-row
          dense
          max-width="100"
        >
          <v-col
            cols="12"
          >
            <h3>著作権について</h3>
          </v-col>
        </v-row>
        <v-row
          dense
          max-width="100"
        >
          <v-col cols="12">
            ・aws-amplify
          </v-col>
          <v-col cols="12">
            Apache License
          </v-col>
          <v-col cols="12">
            Version 2.0, January 2004
          </v-col>
          <v-col cols="12">
            http://www.apache.org/licenses/
          </v-col>
          <br>
          <v-col cols="12">
            TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
          </v-col>
          <br>
          <v-col cols="12">
            1. Definitions.
          </v-col>
          <br>
          <v-col cols="12">
            "License" shall mean the terms and conditions for use, reproduction,
          </v-col>
          <v-col cols="12">
            and distribution as defined by Sections 1 through 9 of this document.
          </v-col>
          <br>
          <v-col cols="12">
            "Licensor" shall mean the copyright owner or entity authorized by
          </v-col>
          <v-col cols="12">
            the copyright owner that is granting the License.
          </v-col>
          <br>
          <v-col cols="12">
            "Legal Entity" shall mean the union of the acting entity and all
          </v-col>
          <v-col cols="12">
            other entities that control, are controlled by, or are under common
          </v-col>
          <v-col cols="12">
            control with that entity. For the purposes of this definition,
          </v-col>
          <v-col cols="12">
            "control" means (i) the power, direct or indirect, to cause the
          </v-col>
          <v-col cols="12">
            direction or management of such entity, whether by contract or
          </v-col>
          <v-col cols="12">
            otherwise, or (ii) ownership of fifty percent (50%) or more of the
          </v-col>
          <v-col cols="12">
            outstanding shares, or (iii) beneficial ownership of such entity.
          </v-col>
          <br>
          <v-col cols="12">
            "You" (or "Your") shall mean an individual or Legal Entity
          </v-col>
          <v-col cols="12">
            exercising permissions granted by this License.
          </v-col>
          <br>
          <v-col cols="12">
            "Source" form shall mean the preferred form for making modifications,
          </v-col>
          <v-col cols="12">
            including but not limited to software source code, documentation
          </v-col>
          <v-col cols="12">
            source, and configuration files.
          </v-col>
          <br>
          <v-col cols="12">
            "Object" form shall mean any form resulting from mechanical
          </v-col>
          <v-col cols="12">
            transformation or translation of a Source form, including but
          </v-col>
          <v-col cols="12">
            not limited to compiled object code, generated documentation,
          </v-col>
          <v-col cols="12">
            and conversions to other media types.
          </v-col>
          <br>
          <v-col cols="12">
            "Work" shall mean the work of authorship, whether in Source or
          </v-col>
          <v-col cols="12">
            Object form, made available under the License, as indicated by a
          </v-col>
          <v-col cols="12">
            copyright notice that is included in or attached to the work
          </v-col>
          <v-col cols="12">
            (an example is provided in the Appendix below).
          </v-col>
          <br>
          <v-col cols="12">
            "Derivative Works" shall mean any work, whether in Source or Object
          </v-col>
          <v-col cols="12">
            form, that is based on (or derived from) the Work and for which the
          </v-col>
          <v-col cols="12">
            editorial revisions, annotations, elaborations, or other modifications
          </v-col>
          <v-col cols="12">
            represent, as a whole, an original work of authorship. For the purposes
          </v-col>
          <v-col cols="12">
            of this License, Derivative Works shall not include works that remain
          </v-col>
          <v-col cols="12">
            separable from, or merely link (or bind by name) to the interfaces of,
          </v-col>
          <v-col cols="12">
            the Work and Derivative Works thereof.
          </v-col>
          <br>
          <v-col cols="12">
            "Contribution" shall mean any work of authorship, including
          </v-col>
          <v-col cols="12">
            the original version of the Work and any modifications or additions
          </v-col>
          <v-col cols="12">
            to that Work or Derivative Works thereof, that is intentionally
          </v-col>
          <v-col cols="12">
            submitted to Licensor for inclusion in the Work by the copyright owner
          </v-col>
          <v-col cols="12">
            or by an individual or Legal Entity authorized to submit on behalf of
          </v-col>
          <v-col cols="12">
            the copyright owner. For the purposes of this definition, "submitted"
          </v-col>
          <v-col cols="12">
            means any form of electronic, verbal, or written communication sent
          </v-col>
          <v-col cols="12">
            to the Licensor or its representatives, including but not limited to
          </v-col>
          <v-col cols="12">
            communication on electronic mailing lists, source code control systems,
          </v-col>
          <v-col cols="12">
            and issue tracking systems that are managed by, or on behalf of, the
          </v-col>
          <v-col cols="12">
            Licensor for the purpose of discussing and improving the Work, but
          </v-col>
          <v-col cols="12">
            excluding communication that is conspicuously marked or otherwise
          </v-col>
          <v-col cols="12">
            designated in writing by the copyright owner as "Not a Contribution."
          </v-col>
          <br>
          <v-col cols="12">
            "Contributor" shall mean Licensor and any individual or Legal Entity
          </v-col>
          <v-col cols="12">
            on behalf of whom a Contribution has been received by Licensor and
          </v-col>
          <v-col cols="12">
            subsequently incorporated within the Work.
          </v-col>
          <br>
          <v-col cols="12">
            2. Grant of Copyright License. Subject to the terms and conditions of
          </v-col>
          <v-col cols="12">
            this License, each Contributor hereby grants to You a perpetual,
          </v-col>
          <v-col cols="12">
            worldwide, non-exclusive, no-charge, royalty-free, irrevocable
          </v-col>
          <v-col cols="12">
            copyright license to reproduce, prepare Derivative Works of,
          </v-col>
          <v-col cols="12">
            publicly display, publicly perform, sublicense, and distribute the
          </v-col>
          <v-col cols="12">
            Work and such Derivative Works in Source or Object form.
          </v-col>
          <br>
          <v-col cols="12">
            3. Grant of Patent License. Subject to the terms and conditions of
          </v-col>
          <v-col cols="12">
            this License, each Contributor hereby grants to You a perpetual,
          </v-col>
          <v-col cols="12">
            worldwide, non-exclusive, no-charge, royalty-free, irrevocable
          </v-col>
          <v-col cols="12">
            (except as stated in this section) patent license to make, have made,
          </v-col>
          <v-col cols="12">
            use, offer to sell, sell, import, and otherwise transfer the Work,
          </v-col>
          <v-col cols="12">
            where such license applies only to those patent claims licensable
          </v-col>
          <v-col cols="12">
            by such Contributor that are necessarily infringed by their
          </v-col>
          <v-col cols="12">
            Contribution(s) alone or by combination of their Contribution(s)
          </v-col>
          <v-col cols="12">
            with the Work to which such Contribution(s) was submitted. If You
          </v-col>
          <v-col cols="12">
            institute patent litigation against any entity (including a
          </v-col>
          <v-col cols="12">
            cross-claim or counterclaim in a lawsuit) alleging that the Work
          </v-col>
          <v-col cols="12">
            or a Contribution incorporated within the Work constitutes direct
          </v-col>
          <v-col cols="12">
            or contributory patent infringement, then any patent licenses
          </v-col>
          <v-col cols="12">
            granted to You under this License for that Work shall terminate
          </v-col>
          <v-col cols="12">
            as of the date such litigation is filed.
          </v-col>
          <br>
          <v-col cols="12">
            4. Redistribution. You may reproduce and distribute copies of the
          </v-col>
          <v-col cols="12">
            Work or Derivative Works thereof in any medium, with or without
          </v-col>
          <v-col cols="12">
            modifications, and in Source or Object form, provided that You
          </v-col>
          <v-col cols="12">
            meet the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            (a) You must give any other recipients of the Work or
          </v-col>
          <v-col cols="12">
            Derivative Works a copy of this License; and
          </v-col>
          <br>
          <v-col cols="12">
            (b) You must cause any modified files to carry prominent notices
          </v-col>
          <v-col cols="12">
            stating that You changed the files; and
          </v-col>
          <br>
          <v-col cols="12">
            (c) You must retain, in the Source form of any Derivative Works
          </v-col>
          <v-col cols="12">
            that You distribute, all copyright, patent, trademark, and
          </v-col>
          <v-col cols="12">
            attribution notices from the Source form of the Work,
          </v-col>
          <v-col cols="12">
            excluding those notices that do not pertain to any part of
          </v-col>
          <v-col cols="12">
            the Derivative Works; and
          </v-col>
          <br>
          <v-col cols="12">
            (d) If the Work includes a "NOTICE" text file as part of its
          </v-col>
          <v-col cols="12">
            distribution, then any Derivative Works that You distribute must
          </v-col>
          <v-col cols="12">
            include a readable copy of the attribution notices contained
          </v-col>
          <v-col cols="12">
            within such NOTICE file, excluding those notices that do not
          </v-col>
          <v-col cols="12">
            pertain to any part of the Derivative Works, in at least one
          </v-col>
          <v-col cols="12">
            of the following places: within a NOTICE text file distributed
          </v-col>
          <v-col cols="12">
            as part of the Derivative Works; within the Source form or
          </v-col>
          <v-col cols="12">
            documentation, if provided along with the Derivative Works; or,
          </v-col>
          <v-col cols="12">
            within a display generated by the Derivative Works, if and
          </v-col>
          <v-col cols="12">
            wherever such third-party notices normally appear. The contents
          </v-col>
          <v-col cols="12">
            of the NOTICE file are for informational purposes only and
          </v-col>
          <v-col cols="12">
            do not modify the License. You may add Your own attribution
          </v-col>
          <v-col cols="12">
            notices within Derivative Works that You distribute, alongside
          </v-col>
          <v-col cols="12">
            or as an addendum to the NOTICE text from the Work, provided
          </v-col>
          <v-col cols="12">
            that such additional attribution notices cannot be construed
          </v-col>
          <v-col cols="12">
            as modifying the License.
          </v-col>
          <br>
          <v-col cols="12">
            You may add Your own copyright statement to Your modifications and
          </v-col>
          <v-col cols="12">
            may provide additional or different license terms and conditions
          </v-col>
          <v-col cols="12">
            for use, reproduction, or distribution of Your modifications, or
          </v-col>
          <v-col cols="12">
            for any such Derivative Works as a whole, provided Your use,
          </v-col>
          <v-col cols="12">
            reproduction, and distribution of the Work otherwise complies with
          </v-col>
          <v-col cols="12">
            the conditions stated in this License.
          </v-col>
          <br>
          <v-col cols="12">
            5. Submission of Contributions. Unless You explicitly state otherwise,
          </v-col>
          <v-col cols="12">
            any Contribution intentionally submitted for inclusion in the Work
          </v-col>
          <v-col cols="12">
            by You to the Licensor shall be under the terms and conditions of
          </v-col>
          <v-col cols="12">
            this License, without any additional terms or conditions.
          </v-col>
          <v-col cols="12">
            Notwithstanding the above, nothing herein shall supersede or modify
          </v-col>
          <v-col cols="12">
            the terms of any separate license agreement you may have executed
          </v-col>
          <v-col cols="12">
            with Licensor regarding such Contributions.
          </v-col>
          <br>
          <v-col cols="12">
            6. Trademarks. This License does not grant permission to use the trade
          </v-col>
          <v-col cols="12">
            names, trademarks, service marks, or product names of the Licensor,
          </v-col>
          <v-col cols="12">
            except as required for reasonable and customary use in describing the
          </v-col>
          <v-col cols="12">
            origin of the Work and reproducing the content of the NOTICE file.
          </v-col>
          <br>
          <v-col cols="12">
            7. Disclaimer of Warranty. Unless required by applicable law or
          </v-col>
          <v-col cols="12">
            agreed to in writing, Licensor provides the Work (and each
          </v-col>
          <v-col cols="12">
            Contributor provides its Contributions) on an "AS IS" BASIS,
          </v-col>
          <v-col cols="12">
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
          </v-col>
          <v-col cols="12">
            implied, including, without limitation, any warranties or conditions
          </v-col>
          <v-col cols="12">
            of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
          </v-col>
          <v-col cols="12">
            PARTICULAR PURPOSE. You are solely responsible for determining the
          </v-col>
          <v-col cols="12">
            appropriateness of using or redistributing the Work and assume any
          </v-col>
          <v-col cols="12">
            risks associated with Your exercise of permissions under this License.
          </v-col>
          <br>
          <v-col cols="12">
            8. Limitation of Liability. In no event and under no legal theory,
          </v-col>
          <v-col cols="12">
            whether in tort (including negligence), contract, or otherwise,
          </v-col>
          <v-col cols="12">
            unless required by applicable law (such as deliberate and grossly
          </v-col>
          <v-col cols="12">
            negligent acts) or agreed to in writing, shall any Contributor be
          </v-col>
          <v-col cols="12">
            liable to You for damages, including any direct, indirect, special,
          </v-col>
          <v-col cols="12">
            incidental, or consequential damages of any character arising as a
          </v-col>
          <v-col cols="12">
            result of this License or out of the use or inability to use the
          </v-col>
          <v-col cols="12">
            Work (including but not limited to damages for loss of goodwill,
          </v-col>
          <v-col cols="12">
            work stoppage, computer failure or malfunction, or any and all
          </v-col>
          <v-col cols="12">
            other commercial damages or losses), even if such Contributor
          </v-col>
          <v-col cols="12">
            has been advised of the possibility of such damages.
          </v-col>
          <br>
          <v-col cols="12">
            9. Accepting Warranty or Additional Liability. While redistributing
          </v-col>
          <v-col cols="12">
            the Work or Derivative Works thereof, You may choose to offer,
          </v-col>
          <v-col cols="12">
            and charge a fee for, acceptance of support, warranty, indemnity,
          </v-col>
          <v-col cols="12">
            or other liability obligations and/or rights consistent with this
          </v-col>
          <v-col cols="12">
            License. However, in accepting such obligations, You may act only
          </v-col>
          <v-col cols="12">
            on Your own behalf and on Your sole responsibility, not on behalf
          </v-col>
          <v-col cols="12">
            of any other Contributor, and only if You agree to indemnify,
          </v-col>
          <v-col cols="12">
            defend, and hold each Contributor harmless for any liability
          </v-col>
          <v-col cols="12">
            incurred by, or claims asserted against, such Contributor by reason
          </v-col>
          <v-col cols="12">
            of your accepting any such warranty or additional liability.
          </v-col>
          <br>
          <v-col cols="12">
            END OF TERMS AND CONDITIONS
          </v-col>
          <br>
          <v-col cols="12">
            APPENDIX: How to apply the Apache License to your work.
          </v-col>
          <br>
          <v-col cols="12">
            To apply the Apache License to your work, attach the following
          </v-col>
          <v-col cols="12">
            boilerplate notice, with the fields enclosed by brackets "{}"
          </v-col>
          <v-col cols="12">
            replaced with your own identifying information. (Don't include
          </v-col>
          <v-col cols="12">
            the brackets!)  The text should be enclosed in the appropriate
          </v-col>
          <v-col cols="12">
            comment syntax for the file format. We also recommend that a
          </v-col>
          <v-col cols="12">
            file or class name and description of purpose be included on the
          </v-col>
          <v-col cols="12">
            same "printed page" as the copyright notice for easier
          </v-col>
          <v-col cols="12">
            identification within third-party archives.
          </v-col>
          <br>
          <v-col cols="12">
            Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
          </v-col>
          <br>
          <v-col cols="12">
            Licensed under the Apache License, Version 2.0 (the "License");
          </v-col>
          <v-col cols="12">
            you may not use this file except in compliance with the License.
          </v-col>
          <v-col cols="12">
            You may obtain a copy of the License at
          </v-col>
          <br>
          <v-col cols="12">
            http://www.apache.org/licenses/LICENSE-2.0
          </v-col>
          <br>
          <v-col cols="12">
            Unless required by applicable law or agreed to in writing, software
          </v-col>
          <v-col cols="12">
            distributed under the License is distributed on an "AS IS" BASIS,
          </v-col>
          <v-col cols="12">
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
          </v-col>
          <v-col cols="12">
            See the License for the specific language governing permissions and
          </v-col>
          <v-col cols="12">
            limitations under the License.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・filesize
          </v-col>
          <v-col cols="12">
            Copyright (c) 2020, Jason Mulligan
          </v-col>
          <v-col cols="12">
            All rights reserved.
          </v-col>
          <br>
          <v-col cols="12">
            Redistribution and use in source and binary forms, with or without
          </v-col>
          <v-col cols="12">
            modification, are permitted provided that the following conditions are met:
          </v-col>
          <br>
          <v-col cols="12">
            * Redistributions of source code must retain the above copyright notice, this
          </v-col>
          <v-col cols="12">
            list of conditions and the following disclaimer.
          </v-col>
          <br>
          <v-col cols="12">
            * Redistributions in binary form must reproduce the above copyright notice,
          </v-col>
          <v-col cols="12">
            this list of conditions and the following disclaimer in the documentation
          </v-col>
          <v-col cols="12">
            and/or other materials provided with the distribution.
          </v-col>
          <br>
          <v-col cols="12">
            * Neither the name of filesize nor the names of its
          </v-col>
          <v-col cols="12">
            contributors may be used to endorse or promote products derived from
          </v-col>
          <v-col cols="12">
            this software without specific prior written permission.
          </v-col>
          <br>
          <v-col cols="12">
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
          </v-col>
          <v-col cols="12">
            AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
          </v-col>
          <v-col cols="12">
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
          </v-col>
          <v-col cols="12">
            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
          </v-col>
          <v-col cols="12">
            FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
          </v-col>
          <v-col cols="12">
            DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
          </v-col>
          <v-col cols="12">
            SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
          </v-col>
          <v-col cols="12">
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
          </v-col>
          <v-col cols="12">
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
          </v-col>
          <v-col cols="12">
            OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・autolinker
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2014 Gregory Jacobs (http://greg-jacobs.com)
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining
          </v-col>
          <v-col cols="12">
            a copy of this software and associated documentation files (the
          </v-col>
          <v-col cols="12">
            Software), to deal in the Software without restriction, including
          </v-col>
          <v-col cols="12">
            without limitation the rights to use, copy, modify, merge, publish,
          </v-col>
          <v-col cols="12">
            distribute, sublicense, and/or sell copies of the Software, and to
          </v-col>
          <v-col cols="12">
            permit persons to whom the Software is furnished to do so, subject to
          </v-col>
          <v-col cols="12">
            the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be
          </v-col>
          <v-col cols="12">
            included in all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          </v-col>
          <v-col cols="12">
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          </v-col>
          <v-col cols="12">
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
          </v-col>
          <v-col cols="12">
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
          </v-col>
          <v-col cols="12">
            LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
          </v-col>
          <v-col cols="12">
            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          </v-col>
          <v-col cols="12">
            WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・axios
          </v-col>
          <v-col cols="12">
            Copyright (c) 2014-present Matt Zabriskie
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・babel/polyfill
          </v-col>
          <v-col cols="12">
            MIT License
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2014-present Sebastian McKenzie and other contributors
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining
          </v-col>
          <v-col cols="12">
            a copy of this software and associated documentation files (the
          </v-col>
          <v-col cols="12">
            Software), to deal in the Software without restriction, including
          </v-col>
          <v-col cols="12">
            without limitation the rights to use, copy, modify, merge, publish,
          </v-col>
          <v-col cols="12">
            distribute, sublicense, and/or sell copies of the Software, and to
          </v-col>
          <v-col cols="12">
            permit persons to whom the Software is furnished to do so, subject to
          </v-col>
          <v-col cols="12">
            the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be
          </v-col>
          <v-col cols="12">
            included in all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          </v-col>
          <v-col cols="12">
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          </v-col>
          <v-col cols="12">
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
          </v-col>
          <v-col cols="12">
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
          </v-col>
          <v-col cols="12">
            LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
          </v-col>
          <v-col cols="12">
            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          </v-col>
          <v-col cols="12">
            WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・blueimp-load-image
          </v-col>
          <v-col cols="12">
            MIT License
          </v-col>
          <br>
          <v-col cols="12">
            Copyright c 2011 Sebastian Tschan, https://blueimp.net
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy of
          </v-col>
          <v-col cols="12">
            this software and associated documentation files (the "Software"), to deal in
          </v-col>
          <v-col cols="12">
            the Software without restriction, including without limitation the rights to
          </v-col>
          <v-col cols="12">
            use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
          </v-col>
          <v-col cols="12">
            the Software, and to permit persons to whom the Software is furnished to do so,
          </v-col>
          <v-col cols="12">
            subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in all
          </v-col>
          <v-col cols="12">
            copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
          </v-col>
          <v-col cols="12">
            FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
          </v-col>
          <v-col cols="12">
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
          </v-col>
          <v-col cols="12">
            IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
          </v-col>
          <v-col cols="12">
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・clipboard
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <v-col cols="12">
            Copyright © 2020 Zeno Rocha &lt;hi@zenorocha.com&gt;
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy of
          </v-col>
          <v-col cols="12">
            this software and associated documentation files (the “Software”), to deal in
          </v-col>
          <v-col cols="12">
            the Software without restriction, including without limitation the rights to
          </v-col>
          <v-col cols="12">
            use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
          </v-col>
          <v-col cols="12">
            the Software, and to permit persons to whom the Software is furnished to do so,
          </v-col>
          <v-col cols="12">
            subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
          </v-col>
          <v-col cols="12">
            FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
          </v-col>
          <v-col cols="12">
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
          </v-col>
          <v-col cols="12">
            IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
          </v-col>
          <v-col cols="12">
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・core-js
          </v-col>
          <v-col cols="12">
            Copyright (c) 2014-2020 Denis Pushkarev
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・dateformat
          </v-col>
          <v-col cols="12">
            (c) 2007-2009 Steven Levithan &lt;stevenlevithan.com&gt;
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining
          </v-col>
          <v-col cols="12">
            a copy of this software and associated documentation files (the
          </v-col>
          <v-col cols="12">
            Software), to deal in the Software without restriction, including
          </v-col>
          <v-col cols="12">
            without limitation the rights to use, copy, modify, merge, publish,
          </v-col>
          <v-col cols="12">
            distribute, sublicense, and/or sell copies of the Software, and to
          </v-col>
          <v-col cols="12">
            permit persons to whom the Software is furnished to do so, subject to
          </v-col>
          <v-col cols="12">
            the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be
          </v-col>
          <v-col cols="12">
            included in all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          </v-col>
          <v-col cols="12">
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          </v-col>
          <v-col cols="12">
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
          </v-col>
          <v-col cols="12">
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
          </v-col>
          <v-col cols="12">
            LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
          </v-col>
          <v-col cols="12">
            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          </v-col>
          <v-col cols="12">
            WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・iconv-lite
          </v-col>
          <v-col cols="12">
            Copyright (c) 2011 Alexander Shtuchkin
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining
          </v-col>
          <v-col cols="12">
            a copy of this software and associated documentation files (the
          </v-col>
          <v-col cols="12">
            Software), to deal in the Software without restriction, including
          </v-col>
          <v-col cols="12">
            without limitation the rights to use, copy, modify, merge, publish,
          </v-col>
          <v-col cols="12">
            distribute, sublicense, and/or sell copies of the Software, and to
          </v-col>
          <v-col cols="12">
            permit persons to whom the Software is furnished to do so, subject to
          </v-col>
          <v-col cols="12">
            the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be
          </v-col>
          <v-col cols="12">
            included in all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          </v-col>
          <v-col cols="12">
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          </v-col>
          <v-col cols="12">
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
          </v-col>
          <v-col cols="12">
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
          </v-col>
          <v-col cols="12">
            LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
          </v-col>
          <v-col cols="12">
            OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          </v-col>
          <v-col cols="12">
            WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・ismobilejs
          </v-col>
          <v-col cols="12">
            MIT License
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2019 Kai Mallea
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in all
          </v-col>
          <v-col cols="12">
            copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          </v-col>
          <v-col cols="12">
            SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・jszip
          </v-col>
          <v-col cols="12">
            The MIT License
          </v-col>
          <v-col cols="12">
            Copyright (c) 2009-2016 Stuart Knightley, David Duponchel, Franz Buchinger, Antonio Afonso
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining
          </v-col>
          <v-col cols="12">
            a copy of this software and associated documentation files (the "Software"),
          </v-col>
          <v-col cols="12">
            to deal in the Software without restriction, including without limitation
          </v-col>
          <v-col cols="12">
            the rights to use, copy, modify, merge, publish, distribute, sublicense,
          </v-col>
          <v-col cols="12">
            and/or sell copies of the Software, and to permit persons to whom
          </v-col>
          <v-col cols="12">
            the Software is furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included
          </v-col>
          <v-col cols="12">
            in all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          </v-col>
          <v-col cols="12">
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
          </v-col>
          <v-col cols="12">
            IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          </v-col>
          <v-col cols="12">
            DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
          </v-col>
          <v-col cols="12">
            TORT OR OTHERWISE, ARISING FROM, OUT OF 7OR IN CONNECTION WITH
          </v-col>
          <v-col cols="12">
            THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・npm-run-all
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2015 Toru Nagashima
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in all
          </v-col>
          <v-col cols="12">
            copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          </v-col>
          <v-col cols="12">
            SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・promise-polyfill
          </v-col>
          <v-col cols="12">
            Copyright (c) 2014 Taylor Hakes
          </v-col>
          <v-col cols="12">
            Copyright (c) 2014 Forbes Lindesay
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・qrcode
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2012 Ryan Day
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・uuid
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2010-2020 Robert Kieffer and other contributors
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・vue
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2013-present, Yuxi (Evan) You
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・vue-router
          </v-col>
          <v-col cols="12">
            MIT License
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2013-present Evan You
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in all
          </v-col>
          <v-col cols="12">
            copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          </v-col>
          <v-col cols="12">
            SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・vuetify
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2016-2020 John Jeremy Leider
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
          <br>
          <v-col cols="12">
            ・vuex
          </v-col>
          <v-col cols="12">
            The MIT License (MIT)
          </v-col>
          <br>
          <v-col cols="12">
            Copyright (c) 2015-present Evan You
          </v-col>
          <br>
          <v-col cols="12">
            Permission is hereby granted, free of charge, to any person obtaining a copy
          </v-col>
          <v-col cols="12">
            of this software and associated documentation files (the "Software"), to deal
          </v-col>
          <v-col cols="12">
            in the Software without restriction, including without limitation the rights
          </v-col>
          <v-col cols="12">
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          </v-col>
          <v-col cols="12">
            copies of the Software, and to permit persons to whom the Software is
          </v-col>
          <v-col cols="12">
            furnished to do so, subject to the following conditions:
          </v-col>
          <br>
          <v-col cols="12">
            The above copyright notice and this permission notice shall be included in
          </v-col>
          <v-col cols="12">
            all copies or substantial portions of the Software.
          </v-col>
          <br>
          <v-col cols="12">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          </v-col>
          <v-col cols="12">
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          </v-col>
          <v-col cols="12">
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          </v-col>
          <v-col cols="12">
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          </v-col>
          <v-col cols="12">
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          </v-col>
          <v-col cols="12">
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          </v-col>
          <v-col cols="12">
            THE SOFTWARE.
          </v-col>
          <br>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
    data: () => ({

    }),
}
</script>

<style>

</style>